import React from "react";
import { useDefaultLangByCountry } from "../../../../hooks/use-default-lang-by-country";
import { LANGUAGE_RULE_COUNTRIES } from "../../../../config/constants";
import { CommunityTitle } from "../../../../components/community/community-title";
import { Icon } from "@iconify/react";
import { MAKEMAKE_LIVE_PLAYLISTS } from "../../../data/makemake-live";
import { useTranslations } from "../../../../hooks/use-translations";
import _ from "lodash";

export const PastEvents = () => {
	const lang = useDefaultLangByCountry({ country: LANGUAGE_RULE_COUNTRIES, defaultLang: "en" });
	const texts = useTranslations({ section: "comunidad_club", lang: lang });
	const eventsPlaylists = [...MAKEMAKE_LIVE_PLAYLISTS];

	return (
		<div className="container">
			<div className="mt-5 mb-4">
				<CommunityTitle.H3
					title={_.get(texts, "makemake_en_vivo.destacados.titulo") || "Destacados"}
				/>
			</div>
			<ul className="row justify-content-center align-items-center p-0 m-0">
				{eventsPlaylists?.map((playlist, i) => {
					return (
						<div
							key={playlist?.id}
							className="past-event-card-container d-flex flex-column col-auto col-md m-2 p-2 d-flex justify-content-center align-items-center"
						>
							<li className="m-2 p-0 past-event-card">
								<a
									className="focusable-red"
									href={`${playlist?.url}`}
									aria-label={`plan-${playlist?.id}`}
									target="_blank"
									rel="noopener noreferrer"
								>
									<img
										className="img img-fluid"
										src={playlist?.img}
										alt={`${playlist?.id}`}
									/>
								</a>
								<div className="hover-effect d-flex justify-content-center align-items-center">
									<div className="play-button p-3 onred-inverse--bg">
										<Icon
											icon="ph:play-fill"
											width={50}
											className="play-icon red-inverse--color"
										/>
									</div>
								</div>
							</li>
							<p className="title secondary-font onbackground-primary--color">
								{_.get(texts, playlist?.name?.translationPath) ||
									playlist?.name?.default}
							</p>
						</div>
					);
				})}
			</ul>
		</div>
	);
};
